<template>
    <div>
        <div class="flex flex-row justify-end  items-end mb-2">
            <v-button color="green" icon="file-export" :disabled="isLoading" @click="exportTable">
                <span v-if="!isLoading">{{ $t('export') }}</span>
                <span v-else>
                    <i class="fa fa-spinner fa-spin"></i> {{ $t('loading') }}
                </span>
            </v-button>
        </div>
        <div class="overflow-x-auto panel">
            <table class="global-table min-w-full border border-gray-300">
                <thead>
                    <tr>
                        <th class="px-4 py-2 border border-gray-300 bg-gray-100">{{ $t('document') }}</th>
                        <th class="px-4 py-2 border border-gray-300 bg-gray-100">%</th>
                        <!-- <th class="px-4 py-2 border border-gray-300 bg-gray-100">{{ $t('status') }}</th> -->
                        <th class="px-4 py-2 border border-gray-300 bg-gray-100">{{ $t('planned_start') }}</th>
                        <th class="px-4 py-2 border border-gray-300 bg-gray-100">{{ $t('planned_end') }}</th>
                        <th class="px-4 py-2 border border-gray-300 bg-gray-100">{{ $t('actual_start') }}</th>
                        <th class="px-4 py-2 border border-gray-300 bg-gray-100">{{ $t('actual_end') }}</th>
                        <th class="px-4 py-2 border border-gray-300 bg-gray-100">{{ $t('response_date') }}</th>
                        <th class="px-4 py-2 border border-gray-300 bg-gray-100">{{ $t('status_request') }}</th>
                        <th class="px-4 py-2 border border-gray-300 bg-gray-100">{{ $t('expiration_date') }}</th>
                        <th class="px-4 py-2 border border-gray-300 bg-gray-100">
                            <i class="fas fa-exclamation-triangle"></i>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="template in templates" :key="template.id"
                        class="hover:bg-gray-100 transition-colors font-bold cursor-pointer">
                        <td class="border px-4 py-2" :class="getColorByGroupId(template.group_id)"
                            @click="goToActivity(template)">
                            {{ template.name }}
                        </td>
                        <td class="border border-gray-300 px-4 py-2 text-xs" :class="getObtentionColorClass(template)">
                            <span v-if="getFirstPermitting(template) && getFirstPermitting(template).activity">
                                <b-progress
                                    :value="parseFloat(getFirstPermitting(template)?.activity?.progress_actual) || 0"
                                    :max="100"
                                    type="is-success"
                                    size="is-medium"
                                    show-value
                                    format="percent"
                                    style="min-width: 80px;"
                                />
                            </span>
                            <span v-else>-</span>
                        </td>
                        <!-- <td class="border border-gray-300 px-4 py-2" :class="getObtentionColorClass(template)"
                            @click="openPermittingModal(template)">
                            {{ getStatus(template) }}
                        </td> -->
                        <td class="border border-gray-300 px-4 py-2" :class="getObtentionColorClass(template)"
                            @click="openPermittingModal(template)">
                            {{ formatShortDate(getFirstPermitting(template) ? getFirstPermitting(template).activity.current_start_date:null) }}
                        </td>
                        <td class="border border-gray-300 px-4 py-2" :class="getObtentionColorClass(template)"
                            @click="openPermittingModal(template)">
                            {{ formatShortDate(getFirstPermitting(template) ? getFirstPermitting(template).activity.current_end_date:null) }}
                        </td>
                        <td class="border border-gray-300 px-4 py-2" :class="getObtentionColorClass(template)"
                            @click="openPermittingModal(template)">
                            {{ formatShortDate(getFirstPermitting(template) ? getFirstPermitting(template).activity.gantt_real_start_date:null) }}
                        </td>
                        <td class="border border-gray-300 px-4 py-2" :class="getObtentionColorClass(template)"
                            @click="openPermittingModal(template)">
                            {{ 
                                getFirstPermitting(template) 
                                && getFirstPermitting(template).activity
                                && Number(getFirstPermitting(template).activity.progress_actual) == 100
                                && getFirstPermitting(template).activity.gantt_real_end_date
                                    ? formatShortDate(getFirstPermitting(template).activity.gantt_real_end_date)
                                    : '-' 
                            }}
                        </td>
                        <td class="border border-gray-300 px-4 py-2" :class="getObtentionColorClass(template)"
                            @click="openPermittingModal(template)">
                            {{ formatShortDate(getFirstPermitting(template) ? getFirstPermitting(template).response_date
                                :
                            null) }}
                        </td>
                        <td @click="openPermittingModal(template)">
                            <b-tag
                                :type="getStatusType(getFirstPermitting(template) ? getFirstPermitting(template).status : null)">
                                {{ getStatusLabel(getFirstPermitting(template) ? getFirstPermitting(template).status :
                                    null)
                                }}
                            </b-tag>
                        </td>
                        <!-- <td class="border border-gray-300 px-4 py-2" :class="getObtentionColorClass(template)"
                            @click="openPermittingModal(template)">
                            {{ formatShortDate(getFirstPermitting(template) ?
                                getFirstPermitting(template).obtention_date :
                            null) }}
                        </td> -->
                        <td class="border border-gray-300 px-4 py-2" :class="getObtentionColorClass(template)"
                            @click="openPermittingModal(template)">
                            {{ formatShortDate(getFirstPermitting(template) ?
                                getFirstPermitting(template).expiration_date :
                            null) }}
                        </td>
                        <td class="border border-gray-300 px-4 py-2 text-center" @click="openPermittingModal(template)">
                            <b-tooltip v-if="getWarningIcon(template).icon" :label="getWarningIcon(template).tooltip"
                                position="is-left">
                                <i :class="[getWarningIcon(template).icon, getWarningIcon(template).color]"
                                    style="cursor: pointer;"></i>
                            </b-tooltip>
                        </td>

                    </tr>
                </tbody>
            </table>
            <permitting-modal ref="permittingModal" :project-id="project.id" :loading-activities="loadingActivities"
                :disabled-permitting="true" @reload-list="reloadPermittingData" />
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import { mapGetters } from 'vuex';
import PermittingModal from '../../components/permittings/permitting-modal.vue';
import * as XLSX from 'xlsx';


export default {
    middleware: "auth",
    title: "permittings",
    menuOption: "3-14",
    components: { PermittingModal },
    data() {
        return {
            templates: [],
            activities: [],
            loadingActivities: false,
            colorClasses: [
                'bg-green-lighter',
                'bg-blue-lighter',
                'bg-orange-lighter',
                'bg-yellow-lighter',
                'bg-purple-lighter',
                'bg-red-lighter',
                'bg-teal-lighter',
                'bg-pink-lighter',
                'bg-indigo-lighter',
                'bg-gray-lighter',
            ],
            templateColorMap: {},
            groupColorMap: {},
            templateGroups: [],
            disabledPermitting:true,
            isLoading: false,
        };
    },
    computed: {
        ...mapGetters({
            user: 'auth/user',
            project: 'app/project',
            company: 'app/company',
            visualConfig: 'app/visualConfig',
            mobile: 'device/mobile'
        }),
    },
    async mounted() {
        await this.loadTemplates();
        await this.loadActivities();
    },
    methods: {
        async loadTemplates() {
            try {
                const { data } = await axios.get(`/api/v2/company/${this.company.id}/project/${this.project.id}/permitting-templates`);
                this.templateGroups = Array.isArray(data) ? data : [];
                this.templates = data.flatMap(group => group.templates);
                const groupIds = [...new Set(this.templates.map(t => t.group_id))];
                this.groupColorMap = {};
                groupIds.forEach((groupId, idx) => {
                    this.groupColorMap[groupId] = this.colorClasses[idx % this.colorClasses.length];
                });
            } catch (error) {
                throw ('Error loading templates:', error);
            }

        },
        async loadActivities() {
            this.loadingActivities = true;
            try {
                const response = await axios.get(`/api/v2/activities`, {
                    params: {
                        p: this.project.id,
                        light: 1,
                        s: 1,
                        per_page: 999,
                        skip_map: 1
                    }
                });
                this.activities = response.data.activities
                    .filter(activity => activity.parent_id === null)
                    .map(activity => ({
                        id: activity.id,
                        label: activity.name,
                        current_start_date: activity.current_start_date,
                        children: (activity.subactivities || []).map(sub => ({
                            id: sub.id,
                            label: sub.name,
                            current_start_date: sub.current_start_date,
                            isLeaf: true
                        })),
                        isLeaf: !(activity.subactivities && activity.subactivities.length)
                    }));
            } catch (error) {
                this.$buefy.toast.open({
                    message: this.$t('error_loading_activities'),
                    type: 'is-danger'
                });
            } finally {
                this.loadingActivities = false;
            }
        },
        getFirstPermitting(template) {
            return template.permittings && template.permittings.length > 0 ? template.permittings[0] : null;
        },
        getGroupColor(name) {
            return this.groupColorMap[name] || '';
        },
        getColorByGroupId(groupId) {
            return this.groupColorMap[groupId] || 'bg-gray-200';
        },
        formatShortDate(dateStr) {
            if (!dateStr) return '-';
            const date = moment(dateStr);
            return date.isValid() ? date.format('DD/MM/YY') : '-';
        },
        getStatus(template) {
            const p = this.getFirstPermitting(template);
            if (!p) return this.$t('initial');
            if (p.request_date && !p.obtention_date && !p.expiration_date) {
                return this.$t('request');
            }
            if (p.obtention_date && p.expiration_date) {
                const expiration = moment(p.expiration_date, 'YYYY-MM-DD');
                if (expiration.isValid() && expiration.isBefore(moment())) {
                    return this.$t('expired');
                }
                return this.$t('valid');
            }
            return this.$t('initial');
        },
        getObtentionColorClass(template) {
            const p = this.getFirstPermitting(template);
            if (!p || !p.activity || !p.activity.current_start_date || !p.activity.current_end_date) {
                return '';
            }
            const obt = moment(p.obtention_date);
            const start = moment(p.activity.current_start_date);
            const end = moment(p.activity.current_end_date);
            if (!obt.isValid() || !start.isValid() || !end.isValid()) {
                return '';
            }
            if (obt.isBetween(start, end, 'day', '[]')) {
                return 'text-blue';
            }
            return 'text-blue';
        },
        getColorByCode(code) {
            return this.templateColorMap[code] || 'bg-gray-200';
        },
        getWarningIcon(template) {
            const p = this.getFirstPermitting(template);
            if (!p || !p.expiration_date) return { icon: '', color: '', tooltip: '' };
            const expiration = moment(p.expiration_date, 'YYYY-MM-DD');
            if (!expiration.isValid()) return { icon: '', color: '', tooltip: '' };
            const diffDays = expiration.diff(moment(), 'days');
            if (diffDays < 0) {
                return {
                    icon: "fas fa-exclamation-triangle",
                    color: "text-red",
                    tooltip: this.$t('expired_permitting')
                };
            } else if (diffDays <= 30) {
                return {
                    icon: "fas fa-exclamation-triangle",
                    color: "text-orange",
                    tooltip: this.$t('expiring_soon_permitting')
                };
            }
            return { icon: '', color: '', tooltip: '' };
        },
        async openPermittingModal(template) {
            const existing = (template.permittings && template.permittings.length > 0)
                ? template.permittings[0]
                : null;

            const payload = existing
                ? existing
                : {
                    id: null,
                    permitting_template_id: template.id,
                    activity_id: null,
                    request_date: null,
                    obtention_date: null,
                    expiration_date: null,
                    planning_date: null,
                };
            this.$refs.permittingModal.show(payload, this.activities, this.templateGroups);
        },

        reloadPermittingData() {
            this.loadTemplates();
        },
        getStatusLabel(status) {
            switch (status) {
                case 0: return this.$t('approved');
                case 1: return this.$t('approved_with_comments');
                case 2: return this.$t('rejected');
                case 3: return this.$t('rejected_with_comments');
                default: return '-';
            }
        },
        getStatusType(status) {
            switch (status) {
                case 0: return 'is-success';
                case 1: return 'is-info';
                case 2: return 'is-danger';
                case 3: return 'is-warning';
                default: return '';
            }
        },
        goToActivity(template) {
            const permitting = this.getFirstPermitting(template);
            if (!permitting || !permitting.activity) {
                this.$buefy.toast.open({
                    message: this.$t('no_results'),
                    type: 'is-warning'
                });
                return;
            }
            const activity = permitting.activity;
            if (!activity.parent_id) {
                this.$router.push({ name: 'activity.home', params: { activity_id: activity.id } });
            } else {
                this.$router.push({
                    name: 'subactivity.home',
                    params: { activity_id: activity.parent_id, subactivity_id: activity.id }
                });
            }
        },
        exportTable() {
            this.isLoading = true;
            axios.post('/api/v2/export/permittings', {
                companyId: this.company.id,
                projectId: this.project.id
            }, { responseType: 'blob' })
            .then(response => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'permittings.xlsx');
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            })
            .catch(() => {
                this.$buefy.toast.open({
                    message: this.$t('error_export'),
                    type: 'is-danger'
                });
            })
            .finally(() => {
                this.isLoading = false;
            });
        },
    },
};
</script>

<style lang="scss" scoped>
::v-deep .global-table th,
::v-deep .global-table td {
    text-align: center !important;
    vertical-align: middle !important;
}

::v-deep .global-table th,
::v-deep .global-table td {
    border: 0.5px solid black !important;
}
</style>